import { useCallback } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Tabs } from '@frontend/design-system';
import { useNavModeStore } from '../stores/store';

export const NavTabs = () => {
  const { t } = useTranslation('nav');
  const { navMode, setNavMode } = useNavModeStore(['navMode', 'setNavMode']);

  const handleNavModeChange = useCallback(
    (id: string) => {
      setNavMode(id as 'all-apps' | 'full');
    },
    [setNavMode]
  );

  return (
    <div css={{ width: '100%', zIndex: 100 }}>
      <Tabs controlledTab={navMode} onChange={handleNavModeChange} css={css({ width: '100%' })}>
        <Tabs.Bar css={{ justifyContent: 'center' }}>
          <Tabs.Tab id='all-apps'>{t('Icon View')}</Tabs.Tab>
          <Tabs.Tab id='full'>{t('Full Menu')}</Tabs.Tab>
        </Tabs.Bar>
      </Tabs>
    </div>
  );
};
